import React, { useEffect } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import App from './App';
import { Login } from './pages/login/Login';
import { OTP } from './pages/login/Otp';

const AppWrapper = (props: any) => {
    let location = useLocation();

    useEffect(() => {
        const handleContextMenu = (e: MouseEvent) => {
            e.preventDefault();
        };

        const handleKeyDown = (e: KeyboardEvent) => {
            // F12
            if (e.key === 'F12' || e.keyCode === 123) {
                e.preventDefault();
                return false;
            }

            // Common DevTools & View Source shortcuts
            if (
                (e.ctrlKey && e.shiftKey && (e.key === 'I' || e.keyCode === 73)) || // Ctrl+Shift+I
                (e.ctrlKey && e.shiftKey && (e.key === 'J' || e.keyCode === 74)) || // Ctrl+Shift+J
                (e.ctrlKey && (e.key === 'U' || e.keyCode === 85)) || // Ctrl+U
                (e.ctrlKey && (e.key === 'S' || e.keyCode === 83)) || // Ctrl+S
                (e.ctrlKey && (e.key === 'H' || e.keyCode === 72)) || // Ctrl+H
                (e.ctrlKey && (e.key === 'A' || e.keyCode === 65)) || // Ctrl+A
                (e.ctrlKey && (e.key === 'E' || e.keyCode === 69)) || // Ctrl+E
                (e.metaKey && e.altKey && (e.key === 'I' || e.keyCode === 73)) || // Cmd+Opt+I (Mac)
                (e.metaKey && ['U', 'S', 'H', 'A', 'E'].includes(e.key.toUpperCase()))
            ) {
                e.preventDefault();
                return false;
            }
        };

        document.addEventListener('contextmenu', handleContextMenu);
        document.addEventListener('keydown', handleKeyDown);

        return () => {
            document.removeEventListener('contextmenu', handleContextMenu);
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, []);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [location]);

    return (
        <Routes>
            <Route path="/" element={<Login />} />
            <Route path="/otp/:mobile" element={<OTP />} />

            <Route path="*" element={<App />} />
        </Routes>
    );
};

export default AppWrapper;
